import AuthenticationPage from "../containers/AuthenticationPage"

let TotemRoutes = [
    {
        path: '/totem',
        forceAuth: null,
        container: AuthenticationPage,
        exact: false,
    },
]

export default TotemRoutes